import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=e6a2fe06"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
import style0 from "./Window.vue?vue&type=style&index=0&id=e6a2fe06&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports